var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVirtualOld(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 262,
    height: 166,
    viewBox: "0 0 262 166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    width: 262,
    height: 166,
    rx: 8.58,
    transform: "translate(31 1140)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "_1234_5678_9",
    x: 195,
    y: 115.5,
    width: 42,
    height: 17,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_74",
    x: 20.5,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_75",
    x: 30.5,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_76",
    x: 40.5,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_77",
    x: 50.5,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_74-2",
    x: 74.502,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_75-2",
    x: 84.502,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_76-2",
    x: 94.502,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_77-2",
    x: 104.502,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_74-3",
    x: 133.498,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_75-3",
    x: 143.498,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_76-3",
    x: 153.498,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_77-3",
    x: 163.498,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "_1234_5678_9-2",
    x: 22,
    y: 115.5,
    width: 52,
    height: 17,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35175",
    "data-name": "Group 35175",
    transform: "translate(23142 1564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6698",
    "data-name": "Mask Group 6698",
    transform: "translate(-23173 -2704)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35697",
    "data-name": "Path 35697",
    d: "M0,0H262.059V166H0Z",
    transform: "translate(31 1140)",
    fill: "#6c8bf5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_42",
    "data-name": "Intersection 42",
    d: "M143,171V0H38.8L0,68.824,57.6,171H143m1,1H57.012L-1.148,68.824,38.217-1H144Z",
    transform: "translate(150 1140)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_43",
    "data-name": "Intersection 43",
    d: "M193.506,123.21a114.387,114.387,0,0,0,.735-12.945C194.241,49.378,146.621,0,87.9,0,51.363,0,19.142,19.094,0,48.179V123.21H193.506m.893,1H-1V47.879l.165-.25A110.84,110.84,0,0,1,15.988,27.651a107.792,107.792,0,0,1,20.95-15.34A104.068,104.068,0,0,1,129.69,7.751a106.236,106.236,0,0,1,18.236,10.264,109.081,109.081,0,0,1,15.885,13.59,111.329,111.329,0,0,1,13.1,16.468,112.634,112.634,0,0,1,9.894,18.9,113.685,113.685,0,0,1,6.252,20.88,115.99,115.99,0,0,1,1.439,35.471Z",
    transform: "translate(30.993 1187.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGID-2",
    "data-name": "SVGID",
    d: "M14.559,0H247.5a14.559,14.559,0,0,1,14.559,14.559V156.507A14.559,14.559,0,0,1,247.5,171.066H14.559A14.559,14.559,0,0,1,0,156.507V14.559A14.559,14.559,0,0,1,14.559,0Z",
    transform: "translate(31 1140)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_44",
    "data-name": "Intersection 44",
    d: "M74.609,115.705a114.241,114.241,0,0,0,.735-12.94C75.344,56,47.24,16.03,7.6,0L0,13.507l57.648,102.2H74.609m.893,1H57.064L-1.148,13.507,7.161-1.257l.815.33a106.3,106.3,0,0,1,27.566,16.4A110.3,110.3,0,0,1,57.167,39.3a112.458,112.458,0,0,1,14.122,29.64,114.884,114.884,0,0,1,5.055,33.825,115.728,115.728,0,0,1-.741,13.054Z",
    transform: "translate(149.904 1195.356)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -23142, -1564)",
    filter: "url(#_1234_5678_9)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_1234_5678_9-3",
    "data-name": "1234   5678   9",
    transform: "translate(216 127.5)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.994,
    y: 0
  }, "Valid thru"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35173",
    "data-name": "Group 35173",
    transform: "translate(-18089 -796)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5053, -768)",
    filter: "url(#Ellipse_74)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74-4",
    "data-name": "Ellipse 74",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(25 96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5053, -768)",
    filter: "url(#Ellipse_75)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75-4",
    "data-name": "Ellipse 75",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(35 96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5053, -768)",
    filter: "url(#Ellipse_76)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76-4",
    "data-name": "Ellipse 76",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(45 96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5053, -768)",
    filter: "url(#Ellipse_77)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77-4",
    "data-name": "Ellipse 77",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(55 96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5053, -768)",
    filter: "url(#Ellipse_74-2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74-5",
    "data-name": "Ellipse 74",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(79 96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5053, -768)",
    filter: "url(#Ellipse_75-2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75-5",
    "data-name": "Ellipse 75",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(89 96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5053, -768)",
    filter: "url(#Ellipse_76-2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76-5",
    "data-name": "Ellipse 76",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(99 96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5053, -768)",
    filter: "url(#Ellipse_77-2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77-5",
    "data-name": "Ellipse 77",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(109 96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5053, -768)",
    filter: "url(#Ellipse_74-3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74-6",
    "data-name": "Ellipse 74",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(138 96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5053, -768)",
    filter: "url(#Ellipse_75-3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75-6",
    "data-name": "Ellipse 75",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(148 96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5053, -768)",
    filter: "url(#Ellipse_76-3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76-6",
    "data-name": "Ellipse 76",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(158 96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5053, -768)",
    filter: "url(#Ellipse_77-3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77-6",
    "data-name": "Ellipse 77",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(168 96)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -23142, -1564)",
    filter: "url(#_1234_5678_9-2)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_1234_5678_9-4",
    "data-name": "1234   5678   9",
    transform: "translate(48 127.5)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans",
    opacity: 0.485
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.002,
    y: 0
  }, "Card holder"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35174",
    "data-name": "Group 35174",
    transform: "translate(-22960.221 -1545.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5879",
    "data-name": "Group 5879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5877",
    "data-name": "Group 5877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5876",
    "data-name": "Group 5876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18228",
    "data-name": "Path 18228",
    d: "M197.666,13.271l-7.492,17.872h-4.887L181.6,16.88a1.962,1.962,0,0,0-1.1-1.57,19.308,19.308,0,0,0-4.561-1.52l.11-.52h7.867a2.153,2.153,0,0,1,2.132,1.821L188,25.435l4.811-12.165Zm19.149,12.036c.019-4.716-6.523-4.976-6.477-7.083.012-.642.624-1.322,1.96-1.5a8.752,8.752,0,0,1,4.56.8l.811-3.79a12.388,12.388,0,0,0-4.324-.792c-4.568,0-7.785,2.43-7.812,5.908-.029,2.572,2.295,4.006,4.047,4.864,1.8.875,2.4,1.436,2.4,2.22-.013,1.2-1.438,1.728-2.766,1.748a9.658,9.658,0,0,1-4.749-1.128l-.838,3.917a14.006,14.006,0,0,0,5.143.948c4.855,0,8.032-2.4,8.048-6.115m12.067,5.835h4.276l-3.73-17.872h-3.949a2.105,2.105,0,0,0-1.967,1.312l-6.935,16.559h4.852l.965-2.668h5.931Zm-5.158-6.333,2.434-6.711,1.4,6.711ZM204.271,13.271l-3.823,17.872h-4.623l3.823-17.872Z",
    transform: "translate(-175.941 -12.945)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5878",
    "data-name": "Group 5878",
    transform: "translate(28.247 22.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18229",
    "data-name": "Path 18229",
    d: "M202.134,34.047a9.164,9.164,0,0,1,1.518-.119,2.519,2.519,0,0,1,1.718.509,1.678,1.678,0,0,1,.536,1.281,1.805,1.805,0,0,1-.472,1.309,2.553,2.553,0,0,1-1.872.673,2.679,2.679,0,0,1-.637-.055V40.1h-.79Zm.79,2.954a2.668,2.668,0,0,0,.655.064c.954,0,1.537-.472,1.537-1.3s-.582-1.21-1.445-1.21a3.375,3.375,0,0,0-.746.064Z",
    transform: "translate(-202.134 -33.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18230",
    "data-name": "Path 18230",
    d: "M206.672,36.951c0-.519-.008-.964-.036-1.373h.7l.036.872h.027a1.331,1.331,0,0,1,1.229-.963,1.522,1.522,0,0,1,.217.017v.754a1.3,1.3,0,0,0-.272-.017A1.113,1.113,0,0,0,207.5,37.26a2.376,2.376,0,0,0-.028.373v2.345h-.8Z",
    transform: "translate(-201.781 -33.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18231",
    "data-name": "Path 18231",
    d: "M210.022,37.923a1.4,1.4,0,0,0,1.509,1.527,2.875,2.875,0,0,0,1.218-.226l.147.573a3.591,3.591,0,0,1-1.473.281,2.051,2.051,0,0,1-2.164-2.228,2.127,2.127,0,0,1,2.064-2.362,2.118,2.118,0,0,1,1.79,2.435Zm2.344-.573a1.136,1.136,0,0,0-1.109-1.291,1.311,1.311,0,0,0-1.227,1.291Z",
    transform: "translate(-201.575 -33.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18232",
    "data-name": "Path 18232",
    d: "M213.991,37.015c0-.564-.019-1.019-.038-1.436h.71l.045.754h.017a1.715,1.715,0,0,1,1.564-.844,1.991,1.991,0,0,1,1.873,2.227,2.088,2.088,0,0,1-2.009,2.363,1.542,1.542,0,0,1-1.355-.691h-.018v2.391h-.789Zm.789,1.171a1.211,1.211,0,0,0,.038.328,1.231,1.231,0,0,0,1.2.936c.845,0,1.336-.69,1.336-1.7,0-.872-.464-1.627-1.309-1.627a1.262,1.262,0,0,0-1.21.982,1.31,1.31,0,0,0-.054.317Z",
    transform: "translate(-201.207 -33.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18233",
    "data-name": "Path 18233",
    d: "M222.11,38.923a7.4,7.4,0,0,0,.064,1.055h-.717l-.065-.554h-.027a1.636,1.636,0,0,1-1.345.655,1.255,1.255,0,0,1-1.347-1.264c0-1.063.947-1.645,2.646-1.636v-.092a.9.9,0,0,0-1-1.008,2.113,2.113,0,0,0-1.154.328l-.182-.537a2.854,2.854,0,0,1,1.454-.381c1.346,0,1.673.918,1.673,1.79Zm-.772-1.191c-.872-.017-1.865.137-1.865.991a.7.7,0,0,0,.746.764,1.111,1.111,0,0,0,1.082-.737.911.911,0,0,0,.037-.255Z",
    transform: "translate(-200.837 -33.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18234",
    "data-name": "Path 18234",
    d: "M224.166,34.461a.477.477,0,0,1-.508.491.47.47,0,0,1-.482-.491.487.487,0,0,1,.5-.5A.48.48,0,0,1,224.166,34.461Zm-.891,5.636V35.7h.8v4.4Z",
    transform: "translate(-200.484 -33.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18235",
    "data-name": "Path 18235",
    d: "M229.266,33.667v5.318c0,.39.018.836.036,1.136h-.709l-.037-.764h-.027a1.588,1.588,0,0,1-1.482.864,2.012,2.012,0,0,1-1.89-2.236,2.1,2.1,0,0,1,1.971-2.354,1.473,1.473,0,0,1,1.328.663h.018V33.667Zm-.792,3.845a1.428,1.428,0,0,0-.036-.336,1.179,1.179,0,0,0-1.155-.918c-.827,0-1.319.727-1.319,1.691,0,.891.446,1.627,1.3,1.627a1.214,1.214,0,0,0,1.173-.955,1.4,1.4,0,0,0,.036-.345Z",
    transform: "translate(-200.328 -33.667)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualOld);
export default __webpack_public_path__ + "static/media/virtual_old.e18f25292dd331ef835ebd44866952ba.svg";
export { ForwardRef as ReactComponent };